import { InjectionToken } from "@angular/core";

export const CUSTOMER_CONFIG = new InjectionToken<ICustomerConfig>('cwt-customer-config');

export type ICustomerConfig = {
    trackingParam: string;
    useTokenInterceptor: boolean;
    useTrackingInterceptor: boolean;
    customerSpaceUrl: string;
}